import { Box, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "src/assets/Logo.svg";
import LogoutButton from "src/shared/components/Button/LogoutButton";

/**
 * Global top app bar (v1 chrome): a calm white bar with the wordmark.
 * Replaces the old brown bar after the palette flip.
 *
 * Desktop: logo left, a visible Logout button on the right. Mobile: the logo is
 * centered and Logout is omitted — on mobile, logging out happens from the
 * Profile tab, keeping the header clean.
 */
const Menu = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", md: "space-between" },
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.borderToken}`,
        py: { xs: 1.5, md: 2 },
        px: { xs: 2.5, md: 6 },
      }}
    >
      <Box
        onClick={() => navigate("/")}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          "& svg": { height: { xs: 22, md: 24 }, width: "auto" },
        }}
      >
        <Logo aria-label="Emerge Career" />
      </Box>

      {/* Visible logout, desktop only — mobile keeps a clean centered logo and
          logs out from the Profile tab. */}
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <LogoutButton
          variant="text"
          sx={{ color: theme.palette.nearBlack, textTransform: "none" }}
        />
      </Box>
    </Box>
  );
};

export default Menu;
